import type { SiteText } from "./types.js";

export const sr: SiteText = {
  nav: { pricing: "Cene", terms: "Uslovi", refund: "Povraćaj", privacy: "Privatnost", login: "Prijava", home: "Početna" },
  hero: {
    title: "Program za zakazivanje sa AI odgovorima",
    text: "Kalendar za salone i berbernice koji rade po zakazivanju. AI asistent odgovara na pitanja klijenata u Instagram porukama i upisuje termine u vaš kalendar, i to samo na osnovu podataka koje je salon uneo.",
    cta: "Pogledajte cene",
    login: "Prijava za salone",
    note: "Bez avansa i bez masovnih poruka. Majstor je uvek glavni.",
  },
  demo: {
    chatTitle: "Instagram Direct",
    messages: [
      { from: "client", text: "Zdravo! Ima li termin sutra posle 17h za fade?" },
      {
        from: "assistant",
        text: "Zdravo! Sutra posle 17h slobodno je 17:30 kod Marka i 18:00 kod Nikole. Fade traje 30 min, 1.500 RSD. Koji termin vam odgovara?",
      },
      { from: "client", text: "17:30 kod Marka." },
      { from: "assistant", text: "Fade kod Marka sutra u 17:30, 1.500 RSD. Da zakažem?" },
      { from: "client", text: "Da." },
      { from: "assistant", text: "Zakazano: sutra u 17:30, fade kod Marka. Vidimo se!" },
    ],
    bookingTitle: "Kalendar",
    booking: { time: "17:30–18:00", client: "Jelena", details: "Fade · Marko · zakazao asistent", status: "potvrđeno" },
  },
  how: {
    title: "Kako radi",
    steps: [
      { title: "Povežete Instagram", text: "Profesionalni nalog salona se povezuje kroz Meta dijalog, bez lozinki i bez pristupa vašem telefonu." },
      {
        title: "Unesete usluge i pravila",
        text: "Iz cenovnika, fotografije ili teksta: cene, trajanje, majstori, radno vreme, pravila otkazivanja. Sve proverite pre nego što asistent počne.",
      },
      {
        title: "Asistent odgovara i zakazuje",
        text: "Odgovara samo iz podataka salona, nudi slobodne termine i upisuje ih u kalendar. Kada ne zna, prosleđuje razgovor majstoru.",
      },
    ],
  },
  features: {
    title: "Šta dobijate",
    items: [
      { title: "Kalendar", text: "Usluge sa cenom i trajanjem, majstori, rasporedi, slobodni dani i ručno zakazivanje u dva dodira." },
      {
        title: "AI odgovori",
        text: "Cene, usluge, adresa, radno vreme i pravila: samo iz podataka salona. Ako odgovora nema, asistent kaže: „proveriću sa majstorom“.",
      },
      { title: "Majstor je uvek glavni", text: "Obaveštenja svim majstorima, dugme „preuzmi razgovor“, asistent ćuti dok majstor odgovara." },
      { title: "Stranica za zakazivanje", text: "Link za Instagram profil i QR kod: klijent zakazuje bez dopisivanja." },
      { title: "Mesečni pregled", text: "Jedan red mesečno: koliko klijenata je asistent zakazao i na koji iznos." },
      { title: "Bez avansa", text: "Ne naplaćujemo ništa vašim klijentima i ne šaljemo masovne poruke." },
    ],
  },
  pricingTeaser: {
    title: "Jedna cena, bez provizija",
    price: "€25",
    per: "mesečno",
    points: ["Prvi mesec probni, naplata posle 30 dana", "Bez ograničenja broja razgovora (uz dnevnu zaštitu od spama)", "Otkazivanje u bilo kom trenutku"],
    cta: "Sve o cenama",
    setup: "Samostalno povezivanje: besplatno. Povežemo za vas: €30 jednokratno.",
  },
  faq: {
    title: "Česta pitanja",
    items: [
      {
        q: "Da li klijenti znaju da razgovaraju sa asistentom?",
        a: "Asistent se ne predstavlja sam, ali na direktno pitanje odgovara iskreno. U podešavanjima možete uključiti da se predstavi odmah.",
      },
      {
        q: "Šta ako asistent ne zna odgovor?",
        a: "Kaže klijentu da će proveriti sa majstorom i prosleđuje razgovor vama. Odgovorite jednom i asistent to pamti za sledeći put.",
      },
      {
        q: "Mogu li da preuzmem razgovor?",
        a: "Da, u svakom trenutku. Dok majstor odgovara, asistent ćuti. Može se i potpuno pauzirati.",
      },
      {
        q: "Šta je potrebno za povezivanje?",
        a: "Profesionalni Instagram nalog salona i Meta poslovni portfolio. Povezivanje ide kroz Meta dijalog, lozinke nam ne dajete.",
      },
      {
        q: "Koliko traje podešavanje?",
        a: "Oko 15 minuta kroz čarobnjak: usluge, majstori, radno vreme, pravila. Ako želite, povežemo za vas za €30 jednokratno.",
      },
      {
        q: "Da li naplaćujete nešto mojim klijentima?",
        a: "Ne. Nema avansa, depozita ni masovnih poruka. Plaćate samo pretplatu salona.",
      },
      {
        q: "Mogu li da otkažem?",
        a: "Da, u bilo kom trenutku sa stranice pretplate. Pristup ostaje do kraja plaćenog perioda.",
      },
    ],
  },
  pricing: {
    title: "Cene",
    subtitle: "Jedna pretplata za ceo salon: kalendar, asistent, stranica za zakazivanje i mesečni pregled.",
    plan: "Pretplata",
    price: "€25",
    per: "mesečno",
    points: [
      "Bez provizija i bez ograničenja broja razgovora (uz dnevnu zaštitu od spama)",
      "Prvi mesec probni: kartica se unosi odmah, naplata posle 30 dana",
      "Otkazivanje u bilo kom trenutku, bez ugovora na godinu",
    ],
    setupTitle: "Povezivanje",
    self: { title: "Povezujete se sami", price: "Besplatno", text: "Čarobnjak za podešavanje, oko 15 minuta." },
    done: {
      title: "Povežemo za vas",
      price: "€30 jednokratno",
      text: "Mi unosimo usluge, cene i pravila i proveravamo asistenta. Plaća se zajedno sa pretplatom.",
    },
    vat: "Porez, ako se obračunava, Paddle računa pri plaćanju prema zemlji kupca i prikazuje ukupan iznos pre plaćanja.",
    mor: "Plaćanja obrađuje Paddle.com, koji je Merchant of Record za sve naše porudžbine.",
    start: "Započni",
  },
  footer: {
    rights: "Sva prava zadržana.",
    tagline: "Kalendar i AI asistent za salone koji rade po zakazivanju.",
    contact: "Kontakt",
    language: "Jezik",
    legal: "Dokumenti",
  },
  draft: "Nacrt: tekst još nije pregledao pravnik.",
  updated: "Poslednja izmena",
};
